import { Fragment } from 'react'
import AppStyleDecider from '../../../../../../../../../../baseComponents/AppsStyleDecider'
import { OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import BuyOrderStatusBar, { BuyOrderStatusBarNew, CreateStatusBarProps } from '../../../BuyOrderStatusBar'
import BuyOrderFinishedStepButtons, { BuyOrderFinishedStepButtonsNew } from '../BuyOrderFinishedStepButtons'

type BuyOrderFinishedStepHeaderProps = & CreateStatusBarProps & OrderStepButtonsBaseComponentProps

const BuyOrderFinishedStepHeaderDecider: React.FC<BuyOrderFinishedStepHeaderProps> = ({ ...rest }) => {
    return (
        <AppStyleDecider DefaultComponent={BuyOrderFinishedStepHeaderDefault} NewComponent={BuyOrderFinishedStepHeaderNew} {...rest} />
    )
}

const BuyOrderFinishedStepHeaderDefault: React.FC<BuyOrderFinishedStepHeaderProps> = ({ ...rest }) => {
    return (
        <div className='flex gap-10 justify-between flex-wrap items-center flex-auto'>
            <BuyOrderStatusBar {...rest} />
            <BuyOrderFinishedStepButtons {...rest} />
        </div>
    )
}

const BuyOrderFinishedStepHeaderNew: React.FC<BuyOrderFinishedStepHeaderProps> = ({ ...rest }) => {
    return (
        <Fragment>
            <BuyOrderStatusBarNew {...rest} />
            <BuyOrderFinishedStepButtonsNew {...rest} />
        </Fragment>
    )
}

export default BuyOrderFinishedStepHeaderDecider